import { action } from "satcheljs";

export interface AccountConfigDialogClosedActionMessage {
    dialogId: string;
}

export const accountConfigDialogClosed: (dialogId: string) => AccountConfigDialogClosedActionMessage = action("accountConfigDialogClosed", (dialogId: string): AccountConfigDialogClosedActionMessage => ({ dialogId }));
